var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("场馆系统")]),
              _c("el-breadcrumb-item", [_vm._v("游泳馆")]),
              _c("el-breadcrumb-item", [_vm._v("场馆管理")]),
              _c("el-breadcrumb-item", [_vm._v("票价信息")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  align: "center",
                  label: "商品价格(元)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.price) + "元")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }